import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const NewCodeSentToEmailAlert = ({
  newCodeSentAlertVisible,
  dismissNewCodeSentAlert = () => {},
  email,
  keyWord
}) => {
  if (!newCodeSentAlertVisible || keyWord !== 'confirmToLogin') {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "200",
    type: "success",
    closeable: true,
    onClose: dismissNewCodeSentAlert,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.confirmToLogin.newCodeSuccess.title"
    }),
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.confirmToLogin.newCodeSuccess.body",
        options: {
          email
        }
      })
    })
  });
};
export default NewCodeSentToEmailAlert;